import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as space from '../space'

export const RESOURCE = {
  payload: {
    alias: 'space:user-access',
    appAlias: space.RESOURCE.payload.alias,
    description:
      'Manage survey admins and standard user organization assignments in Space Full',
    display: {
      isMain: false,
      position: 1,
    },
    name: 'User Access',
    page: { id: prebuilt.Page.Id.SpaceUserAccess },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
